import { render, staticRenderFns } from "./glorylist.vue?vue&type=template&id=235fff6c&scoped=true&"
import script from "./glorylist.vue?vue&type=script&lang=js&"
export * from "./glorylist.vue?vue&type=script&lang=js&"
import style0 from "./glorylist.vue?vue&type=style&index=0&id=235fff6c&scoped=%20scoped&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235fff6c",
  null
  
)

export default component.exports